import { call, put, takeEvery, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { getTransactionsApi } from '../../api/transactionApi';
import {
  FETCH_TRANSACTIONS_REQUEST,
  FETCH_TRANSACTIONS_SUCCESS,
  FETCH_TRANSACTIONS_FAILURE,
} from '../constants/transactionConstants';

function* fetchTransactionsSaga(action) {
  try {
    const { user } = yield select((state) => state.auth);
    const almataId = user?.almataPartner?.id || user?.id || user?._id;
    
    const params = {
      ...action.payload,
      almataId,
    };

    const response = yield call(getTransactionsApi, params);
    
    yield put({
      type: FETCH_TRANSACTIONS_SUCCESS,
      payload: response,
    });
  } catch (error) {
    console.error('Transaction fetch error:', error);
    yield put({
      type: FETCH_TRANSACTIONS_FAILURE,
      payload: error.response?.data?.message || error.message || 'An error occurred',
    });
    toast.error(error.response?.data?.message || 'Failed to fetch transaction data');
  }
}

function* transactionSaga() {
  yield takeEvery(FETCH_TRANSACTIONS_REQUEST, fetchTransactionsSaga);
}

export default transactionSaga;